import React from 'react'
import { List, ListItemButton, ListItemIcon, ListItemText, Popover } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ContentCopy, Delete } from '@mui/icons-material'

type FormStructuresActionsMenuProps = {
    anchorEl?: null | HTMLElement
    id?: string
    onClose: () => void
    onCopyStructure: (id: string) => void
    onDeleteAction: (id: string) => void
}

export const FormStructuresActionsMenu: React.FC<FormStructuresActionsMenuProps> = ({
    anchorEl,
    onClose,
    id,
    onCopyStructure,
    onDeleteAction,
}) => {
    const { t } = useTranslation()

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            anchorOrigin={{
                horizontal: 'left',
                vertical: 'bottom',
            }}
            onClose={onClose}
            PaperProps={{ sx: { minWidth: 200 } }}
        >
            <List sx={{ width: '100%' }}>
                <ListItemButton onClick={() => onCopyStructure(id!)}>
                    <ListItemIcon>
                        <ContentCopy />
                    </ListItemIcon>
                    <ListItemText primary={t('structurePage.copyStructure')} />
                </ListItemButton>

                <ListItemButton onClick={() => onDeleteAction(id!)}>
                    <ListItemIcon>
                        <Delete />
                    </ListItemIcon>
                    <ListItemText primary={t('common.delete')} />
                </ListItemButton>
            </List>
        </Popover>
    )
}
